import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "../../lib/cn";

export function Card({
  title,
  children,
  className,
  ...props
}: { title?: string; children: ReactNode } & HTMLAttributes<HTMLElement>) {
  return (
    <section
      className={cn("bg-card text-card-foreground rounded-lg border p-6 shadow-xs", className)}
      {...props}
    >
      {title ? <h1 className="mb-4 mt-0">{title}</h1> : null}
      {children}
    </section>
  );
}
